import { render, staticRenderFns } from "./training_results.vue?vue&type=template&id=cff2f1e2&scoped=true"
import script from "./training_results.vue?vue&type=script&lang=js"
export * from "./training_results.vue?vue&type=script&lang=js"
import style0 from "./training_results.vue?vue&type=style&index=0&id=cff2f1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff2f1e2",
  null
  
)

export default component.exports